
const prefix = '/onlinecs/operationLog'

/**
 * 查询操作日志列表
 * @type {string}
 */
export const queryOperationLogList = `${prefix}/queryOperationLogList`

/**
 * 查询文件导入日志列表
 * @type {string}
 */
export const queryFileImportLogList = `${prefix}/queryFileImportLogList`

/**
 * 操作内容列表
 * @type {string}
 */
export const getOperationContentList = `${prefix}/getOperationContentList`

/**
 * 查询文件导出日志列表
 * @type {string}
 */
export const queryFileExportLogList = `${prefix}/queryFileExportLogList`

/**
 * 获取所属模块列表
 * @type {string}
 */
export const getModuleList = `${prefix}/getModuleList`

/**
 * 删除单个导出日志
 * @type {string}
 */
export const removeFileExportLog = `${prefix}/removeFileExportLog`

/**
 * 更新导出下载次数
 * @type {string}
 */
export const updateDownloadCount = `${prefix}/updateDownloadCount`
